import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  key: 2,
  class: "row mt-20"
}
const _hoisted_3 = { class: "col span-9" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "mmt-8" }
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = { class: "col span-3" }
const _hoisted_8 = {
  key: 3,
  class: "row"
}
const _hoisted_9 = { class: "col span-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_Banner = _resolveComponent("Banner")!
  const _component_LabeledSelect = _resolveComponent("LabeledSelect")!
  const _component_MatchExpressions = _resolveComponent("MatchExpressions")!
  const _component_RcButton = _resolveComponent("RcButton")!
  const _component_TargetsList = _resolveComponent("TargetsList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($data.targetMode !== 'advanced')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_RadioGroup, {
            name: "targetMode",
            "data-testid": "fleet-target-cluster-radio-button",
            value: $options.isLocal ? 'local' : $data.targetMode,
            mode: $props.mode,
            options: $options.targetModeOptions,
            disabled: $options.isView,
            "onUpdate:value": $options.selectTargetMode
          }, null, 8, ["value", "mode", "options", "disabled", "onUpdate:value"])
        ]))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createTextVNode()),
    ($data.targetMode === 'advanced')
      ? (_openBlock(), _createBlock(_component_Banner, {
          key: 1,
          class: "row",
          color: "warning",
          label: _ctx.t('fleet.clusterTargets.advancedConfigs')
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _cache[10] || (_cache[10] = _createTextVNode()),
    ($data.targetMode === 'clusters')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t('fleet.clusterTargets.title')), 1),
            _cache[6] || (_cache[6] = _createTextVNode()),
            _createVNode(_component_LabeledSelect, {
              "data-testid": "fleet-target-cluster-name-selector",
              class: "mmt-4",
              value: $data.selectedClusters,
              label: _ctx.t('fleet.clusterTargets.label'),
              options: $options.clustersOptions,
              taggable: true,
              "close-on-select": false,
              mode: $props.mode,
              multiple: true,
              placeholder: _ctx.t('fleet.clusterTargets.placeholders.selectMultiple'),
              "onUpdate:value": $options.selectClusters
            }, null, 8, ["value", "label", "options", "mode", "placeholder", "onUpdate:value"]),
            _cache[7] || (_cache[7] = _createTextVNode()),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.t('fleet.clusterTargets.rules.title')), 1),
              _cache[4] || (_cache[4] = _createTextVNode()),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.clusterSelectors, (selector, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: selector.key,
                  class: "match-expressions-container mmt-4"
                }, [
                  _createVNode(_component_MatchExpressions, {
                    ref_for: true,
                    ref: `match-expression-${ selector.key }`,
                    class: "body",
                    value: selector,
                    mode: $props.mode,
                    "initial-empty-row": true,
                    "label-key": _ctx.t('fleet.clusterTargets.rules.labelKey'),
                    "add-icon": 'icon-plus',
                    "add-class": 'btn-sm',
                    "onUpdate:value": ($event: any) => ($options.updateMatchExpressions(i, $event, selector.key))
                  }, null, 8, ["value", "mode", "label-key", "onUpdate:value"]),
                  _cache[1] || (_cache[1] = _createTextVNode()),
                  _createVNode(_component_RcButton, {
                    small: "",
                    link: "",
                    onClick: ($event: any) => ($options.removeMatchExpressions(selector.key))
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createElementVNode("i", { class: "icon icon-x" }, null, -1)
                    ])),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 128)),
              _cache[5] || (_cache[5] = _createTextVNode()),
              _createVNode(_component_RcButton, {
                small: "",
                secondary: "",
                class: "mmt-6",
                onClick: $options.addMatchExpressions
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "icon icon-plus" }, null, -1)),
                  _cache[3] || (_cache[3] = _createTextVNode()),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('fleet.clusterTargets.rules.addSelector')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _cache[8] || (_cache[8] = _createTextVNode()),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TargetsList, {
              class: "target-list",
              clusters: $props.matching,
              "empty-label": _ctx.t('fleet.clusterTargets.rules.matching.placeholder')
            }, null, 8, ["clusters", "empty-label"])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[11] || (_cache[11] = _createTextVNode()),
    ($data.targetMode === 'all' && !$options.isLocal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_TargetsList, {
              class: "target-list mt-20",
              clusters: $props.matching
            }, null, 8, ["clusters"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}